import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Auth } from "@/lib/auth";
import { QueryClient } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { DevTools } from "@/components/DevTools";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: Auth;
}>()({
  component: () => {
    return (
      <>
        <div className="flex flex-col items-start">
          <Outlet />
        </div>
        <Toaster position={"top-right"} closeButton />
        <DevTools />
      </>
    );
  },
});
